import {
  ModalContainer
} from "./chunk-D55HY4ZG.mjs";
import {
  IconButton
} from "./chunk-4IBR4GAB.mjs";
import {
  Close_default
} from "./chunk-ONOYXPIT.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/modal/modal.tsx
import { Dialog } from "@headlessui/react";
import React from "react";
var Modal = ({
  title,
  onClose,
  isCloseable = true,
  children,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(ModalContainer, { onClose: isCloseable ? onClose : () => null, ...props }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `w-[calc(100vw-32px)] max-w-[500px] overflow-hidden rounded bg-surface text-foreground`
    },
    /* @__PURE__ */ React.createElement(
      "header",
      {
        className: cn(
          "relative flex items-center justify-between py-4 pl-4 ",
          {
            "border-b pr-[52px]": title
          }
        )
      },
      title && /* @__PURE__ */ React.createElement(Dialog.Title, { as: "h1", className: "flex-1 my-label-md" }, title),
      isCloseable && /* @__PURE__ */ React.createElement(
        IconButton,
        {
          title: "Close",
          className: "absolute right-1.5 top-1.5",
          onClick: onClose
        },
        /* @__PURE__ */ React.createElement(Close_default, null)
      )
    ),
    /* @__PURE__ */ React.createElement(Dialog.Description, { as: "div" }, children)
  ));
};

export {
  Modal
};
